import { initializeApp } from "firebase/app";
import { getDatabase, ref } from "firebase/database";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
// VAPT Fix: removed `measurementId` from Firebase config. When measurementId is
// present, the Firebase SDK auto-loads Google Analytics, which sets `_ga` and
// `_ga_<streamId>` cookies WITHOUT the Secure flag (scanner flags them).
// Our app does not use Firebase Analytics (only Auth + Realtime DB + Functions),
// so removing the field is a safe no-op for functionality.
const firebaseConfig = {
  apiKey: "AIzaSyDnmIoIGiNYle-8-ari86x-tf0QJMOpPZU",
  authDomain: "oxyto-chat.firebaseapp.com",
  databaseURL: "https://oxyto-chat-default-rtdb.firebaseio.com",
  projectId: "oxyto-chat",
  storageBucket: "oxyto-chat.appspot.com",
  messagingSenderId: "75937472813",
  appId: "1:75937472813:web:ad4421af76dff3e9ce73a4"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyCUq_g-17r_nb8js9KT_tvDC-ewGennlwI",
//   authDomain: "karnatakasottoprod.firebaseapp.com",
//   projectId: "karnatakasottoprod",
//   storageBucket: "karnatakasottoprod.firebasestorage.app",
//   messagingSenderId: "513597505595",
//   appId: "1:513597505595:web:de09e5e4736cb11201dc1e",
//   measurementId: "G-V3MF6C5C97"
// };
if (location.host == "registry.transtan.tn.gov.in") {
  firebaseConfig.databaseURL = "https://oxyto-chat-default-rtdb.firebaseio.com"
}
// eslint-disable-next-line no-unused-vars
const app = initializeApp(firebaseConfig);
const PUBLIC_KEY =
  "BIDKf6M2qbfA5SoYPZ2Hw5WxWnqaX2F8I0tNuacOMa8JEYHwR_tSwMhmutuznNeFtNV46crUP9LpdXES3B1wmQo";
const FUNCTIONS = getFunctions(app);
// connectFunctionsEmulator(FUNCTIONS, "localhost", "5001");
const DB = getDatabase(app);
const CHAT_ROOMS = ref(DB, "chat_rooms");
const AUTH = getAuth();
export {
  PUBLIC_KEY, DB, CHAT_ROOMS, AUTH, FUNCTIONS
};
